export default __webpack_public_path__ + "static/media/by.3a1ae218.svg";